<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 09:36:33
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 15:30:10
 * @Description: 鲸鱼一号 - 标的列表
 -->

<template>
  <div class="project-list-wrapper number-one-wrap">
    <div class="nav">
      <h3 class="title"><span>鲸鱼一号</span></h3>
      <router-link to="m-number-one-list" class="more">
        更多<i class="icon iconfont icon-arrow-right"></i>
      </router-link>
    </div>
    <ul class="project-list" v-loading="loading">
      <template v-if="projectList.length > 0">
        <li
          class="project-item"
          v-for="(item, index) in projectList"
          :key="index"
          :class="{ disable: item.progress >= 1 }"
          @click="toDetail(item.id)"
        >
          <div class="header">
            <div class="title">
              <h3 class="name">{{ item.name }}</h3>
            </div>
            <div class="remain-box">
              剩余可投<span>{{ item.remain }}</span
              >元
            </div>
          </div>
          <div class="content">
            <div class="rate-box box">
              <p class="rate">
                <span>{{ item.rate }}</span>
                <i>%</i>
              </p>
              <p class="text">约定年化借款利率</p>
            </div>
            <div class="limit-box box">
              <p class="month">
                <span>{{ item.limit }}</span>
                <i>个月</i>
              </p>
              <p class="text">项目期限</p>
            </div>
            <div class="invest-box box">
              <div class="btn" v-if="item.progress < 1">
                立即购买
              </div>
            </div>
          </div>
        </li>
      </template>
      <div class="no-data" v-else>暂无数据</div>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'project-list',
  data() {
    return {
      projectList: [
        // {
        //   id: 1,
        //   name: '', // 标的名称
        //   type: '鲸鱼优选', // 标的类型
        //   rate: '7.00', // 约定年化借款利率
        //   limit: 0, // 项目期限
        //   remain: '0.00', // 剩余金额
        //   progress: 0.0 // 投标进度
        // }
      ],
      loading: false,
      total: 0,
      currentPage: 1
    };
  },
  created() {
    this.requestList(this.currentPage);
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: `/m-perfect-select/m-project-detail/m-detail-content/${id}/${2}`
      });
    },
    handleCurrentChange() {
      this.requestList(this.currentPage);
    },
    async requestList(page) {
      this.loading = true;
      try {
        const res = await this.$http.post('/cg/commonRequest', {
          method: 'Oproject.list',
          token: '',
          page
        });
        if (res.code === 200) {
          this.projectList = res.data.data.slice(0, 6).map(item => {
            return {
              id: item.projectid,
              name: item.project_name,
              type: '鲸鱼优选',
              limit: item.project_period,
              rate: item.rate_init,
              remain: item.residue_money.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'),
              // progress: parseFloat(item.reduis_moneys / item.moneys).toFixed(2)
              progress: parseFloat(item.percent.split('%')[0] / 100).toFixed(2)
            };
          });
          this.total = res.data.count;
          this.loading = false;
        } else {
          this.$message.error(res.code);
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.project-list-wrapper {
  &.number-one-wrap {
    margin-top: 0.18rem;
  }
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.86rem;
    background: #fff;
    padding: 0 0.3rem;
    .title {
      font-family: 'PingFangSC-Semibold';
      font-size: 0.32rem;
      color: #000000;
      line-height: 1;
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        margin: 0 20px 0 0;
      }
      i {
        display: inline-block;
        position: relative;
        padding: 0 30px 0 10px;
        background: #2c6eff;
        color: #fff;
        font-family: 'PingFangSC-Regular';
        font-size: 16px;
        &::before {
          content: '';
          position: absolute;
          top: 0;
          right: -1px;
          // border-left: 10px solid transparent;
          border-right: 16px solid transparent;
          border-top: 16px solid #fff;
          transform: rotate(90deg);
        }
        &::after {
          content: '';
          position: absolute;
          right: -1px;
          bottom: 0;
          // border-left: 10px solid transparent;
          border-right: 16px solid transparent;
          border-top: 16px solid #fff;
          transform: rotate(180deg);
        }
      }
    }
    .more {
      font-family: 'PingFangSC-Regular';
      font-size: 0.24rem;
      line-height: 1;
      cursor: pointer;
      .icon {
        font-size: 0.2rem;
        margin-left: 0.02rem;
      }
    }
  }
  .project-list {
    min-height: 300px;
    .project-item {
      background: #fff;
      padding: 0 0.3rem;
      border-top: solid 0.01rem #ededed;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 1;
        padding: 0.4rem 0 0.34rem;
        .title {
          max-width: 55%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .name {
          font-family: 'PingFangSC-Medium';
          font-size: 0.26rem;
          line-height: 0.38rem;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
        }
        .type {
          width: 1.08rem;
          height: 0.3rem;
          background-color: #f46c19;
          border-radius: 0.08rem;
          color: #ffffff;
          text-size-adjust: none;
          -webkit-text-size-adjust: none;
          font-size: 0.2rem;
          line-height: 0.3rem;
          text-align: center;
          margin-left: 0.42rem;
        }
        .remain-box {
          max-width: 45%;
          font-size: 0.24rem;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .content {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0.39rem;
        .box {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          line-height: 1;
          height: 100%;
          font-family: 'PingFangSC-Medium';
          text-align: left;
          .text {
            font-family: 'PingFangSC-Regular';
            font-size: 0.24rem;
            color: #9e9e9e;
            margin: 0.1rem 0 0 0;
          }
        }
        .rate-box {
          .rate {
            color: #0d72e2;
            span {
              font-size: 0.5rem;
            }
            i {
              font-size: 0.24rem;
            }
          }
        }
        .limit-box {
          .month {
            span {
              font-size: 0.48rem;
              color: #333333;
            }
            i {
              font-size: 0.24rem;
            }
          }
        }

        .invest-box {
          align-self: flex-end;
          .btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 1.6rem;
            font-size: 0.26rem;
            height: 0.68rem;
            line-height: 0.68rem;
            background-color: #0d72e2;
            border-radius: 0.11rem;
            text-align: center;
            // line-height: 68px;
            font-family: 'PingFangSC-Regular';
            color: #ffffff;
          }
        }
      }
    }
    .project-item.disable {
      background: #fff;
      .type {
        background-color: #999999;
      }
      .text {
        color: #999999;
      }
      .rate-box {
        .rate {
          color: #999999;
        }
      }
      .limit-box {
        .month {
          color: #999999;
        }
      }
      .invest-box {
        width: 1.28rem;
        height: 1.03rem;
        background: url('https://files.jinr.com/jinr-index/img/bid-full.png') no-repeat center;
        background-size: 88%;
      }
    }
    .pagination {
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }
    .no-data {
      text-align: center;
      font-size: 30px;
      line-height: 300px;
      color: #ccc;
      background: #fff;
    }
  }
}
</style>
